import api from 'api'
import { CACHE_TAG_FOLLOW_UP_LIST } from '../cacheTagTypes'
import { withIdTag } from 'utils/cache'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addFollowUpAdditionalNotes: build.mutation({
      query: body => ({ url: '/api/account/follow-up/note/add', method: 'POST', body }),
      invalidatesTags: (result, error, arg) => withIdTag(CACHE_TAG_FOLLOW_UP_LIST, arg?.followUpId || arg?.id),
    }),
  }),
})

export const { useAddFollowUpAdditionalNotesMutation } = extendedApi
